import React from "react";
import axios from 'axios';
import Products from "../Components/Products";
import './ProductList.css';
//import Slider from "react-slick";
import { useParams } from "react-router-dom";
import Loader from "../Components/Loader";
class Slideproductlist extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],check:false,root:[]
        }
    }; 
    componentDidMount(){
        
        //alert("ok")
        this.setState({check:true})
        //let {value}= this.props.params
        //console.log(id2)
        //this.setState({root:id2})
       
        
        
       
        //alert(id2)
        axios.get(encodeURI(process.env.REACT_APP_API_URL + this.props.url +localStorage.getItem('pin')), {
            headers : { 
        'content-type': 'application/json'}
        })
                .then(response=>{
                    this.setState({list:response.data.message})
                    //console.log(response.data.message) 
                    this.setState({check:false}) 
                })
                .catch(response=>{
                    //console.log(response+'api/method/ecom.api.item_list?item_group_route='+this.props.route)
                })
       


    } 
    render() {
        var obj = [...this.state.list];
        obj.sort((a,b) => b.stock - a.stock);
//alert(this.props.params['*'])
         return this.state.check ? <Loader/> :
         <div> 
         <div className="shop-category-area">
                    <div className="container">
                        {/*  <Listslider minilist={this.props.params['*']}/> */}
                        <div className="row">
                            <div className="col-md-12">

                                <div className="shop-bottom-area mt-35">
                                {/*   <!-- Shop Tab Content Start --> */}
                                    <div className="tab-content jump">
                                        {/*  <!-- Tab One Start --> */}
                                        <div id="shop-1" className="tab-pane active">
                                            <div className="row m-0">
                                            {obj.map((itm,k)=>{
                            return(
                                            <Products key={k} data={itm}/>)
                                        })} 
                                               
                                            </div>
                                        </div>
                                    {/*  <!-- Tab One End --> */}
                                        
                                    </div>
                                    {/* <!-- Shop Tab Content End -->
                                    <!--  Pagination Area Start --> */}
                                    
                                    {/*  <!--  Pagination Area End --> */}
                                </div>
                                {/* <!-- Shop Bottom Area End --> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                /* <!-- Shop Category Area End --> */
              }
            }
           // export default ProductList;
           export default (props) => (
            <Slideproductlist
                {...props}
                params={useParams()}
        />)
        